<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4">
      <h3>CXC</h3>
      <v-btn v-if="false" color="warning" depressed @click="editCuentasFix()">
        Corregir Folios (Prueba ID)
      </v-btn>
    </div>
    <div>
      <uv-data-table ref="cuentasTable" :config="config" :data="Cuentas" :pageRows="15"
        @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="CXC">
      <formCuenta :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </formCuenta>
    </modal>
    <modal v-model="showEditModal" :showFooter="false" title="CXC">
      <CuentaEdit :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData" @reload="
        getCuentas();
      toggleModal(false);
      ">
      </CuentaEdit>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import formCuenta from "../Cuentas/FormCuenta.vue";
import Cliente from "../../../clases/Cliente.js";
import moment from "moment";
import CuentaEdit from "./CuentaEdit.vue";
import CuentaCXCExcel from "../../../clases/ExcelMaker/CuentaCXCExcel.js";
import { updateDoc } from "firebase/firestore";
export default {
  name: "CuentaCRUD",
  components: {
    modal,
    uvDataTable,
    formCuenta,
    CuentaEdit,
  },
  props: [],
  data() {
    return {
      Cuentas: [],
      MainDepartamento: "",
      showModal: false,
      showEditModal: false,
      formIndex: 0,
      editMode: false,
      editData: [],
      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "CxC",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          /*{
            text: "Ver detalle",
            icon: "lni lni-list",
            buttonId: "viewDetail",
            require: true,
          },*/
          {
            text: "Ver",
            icon: "lni lni-pencil-alt",
            buttonId: "editCuenta",
            require: true,
          },
          {
            text: "Exportar Excel",
            icon: "lni lni-files",
            buttonId: "excelExport",
            require: false,
          },
        ],
        fields: [
          {
            title: "Cliente",
            dataName: "NombreCompleto",
            text: "Cliente",
            value: "NombreCompleto",
          },
          {
            title: "Cliente",
            dataName: "NombreCompleto",
            text: "Identificador",
            value: "id",
          },
          {
            text: "Fecha creación",
            value: "FechaCreacion",
            format: (row) => {
              let d = new Date(row["FechaCreacion"]);
              return new moment(d).format("DD-MM-YYYY HH:mm");
            },
          },
          {
            title: "Total CXC",
            dataName: "Totales",
            text: "Total CXC",
            value: "total",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row.total ? row.total : 0);
            },
          },
          {
            title: "Moneda",
            dataName: "Totales",
            text: "Moneda",
            value: "moneda",
          },

          {
            title: "Productos",
            dataName: "Catalogo", //'Existencia',
            text: "Productos",
            value: "Catalogo",
            format: (row) => {
              return row["Catalogo"].length;
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "viewDetail") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.Cuentas,
          "id",
          idSelected[0],
        );
        this.editData = this.$pgsHelper.cloneObj(prodEdit);
        this.showModal = true;
      }
      if (buttonId == "editCuenta") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.Cuentas,
          "id",
          idSelected[0],
        );
        this.editData = this.$pgsHelper.cloneObj(prodEdit);
        this.showEditModal = true;
      }
      if (buttonId == "excelExport") {
        const dt = this.$refs.cuentasTable;

        const rows = dt && typeof dt.retrieveData === "function"
          ? dt.retrieveData()
          : this.Cuentas;

        const visibleRows = rows && rows.length ? rows : this.Cuentas;

        const dataToExport = this.$pgsHelper.cloneObj(visibleRows);

        this.exportExcel(dataToExport);
      }
    },

    exportExcel(data) {
      // Pasamos visibleRows directamente al generador
      CuentaCXCExcel.generateExcelBuffer(data)
        .then((buffer) => this.downloadExcel(buffer))
        .catch((e) => console.error("Error exportando:", e));
    },
    downloadExcel(buffer) {
      const name = "CXC";
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${name}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    successData(data) {
      this.$pgsHelper.log(data);
      let sendData = {};

      sendData.Catalogo = data.productos;
      sendData.Mayoristas[data.mayorista] = true;
      sendData.Departamentos[this.MainDepartamento] = true;
      this.$pgsHelper.log(sendData);
      if (data.Id == "" || !data.Id) {
        this.createCupon(sendData);
      } else {
        sendData.Id = data.Id;
        this.editCupon(sendData);
      }
    },

    toggleModal(open) {
      this.showModal = open;
      this.showEditModal = open;
    },

    async getCuentas() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_CuentaConsumo", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ]);

      this.Cuentas = data.docs.map((doc) => {
        const rowData = doc.data();

        // Búsqueda de datos del cliente
        const clienteData = Cliente.getById(rowData.Cliente);
        const NombreCompleto = clienteData
          ? clienteData.getNombreCompleto()
          : "Sin Cliente";

        // Evaluación de totales
        const Totales = rowData.Totales || {};
        const total = Totales.MXN ? Totales.MXN : Totales.USD || 0;
        const moneda = Totales.MXN ? "MXN" : "USD";

        return {
          id: doc.ref.id,
          ...rowData,
          clienteData,
          NombreCompleto,
          total,
          moneda,
        };
      });
    },

    async editCuentasFix(id = null) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      if (id) {
        const docRef = firestore.doc("PDV_CuentaConsumo", id);
        const documentSnapshot = await firestore.getDoc(docRef);

        if (documentSnapshot.exists()) {
          const rowData = documentSnapshot.data();
          let updated = false;

          if (rowData.Catalogo && Array.isArray(rowData.Catalogo) && rowData.Catalogo.length > 0) {
            rowData.Catalogo.forEach((item) => {
              if (!item.ExtraParams) {
                item.ExtraParams = {};
              }
              if (!item.ExtraParams.CuentaData) {
                item.ExtraParams.CuentaData = {};
              }
              if (item.ExtraParams.CuentaData.Folio === undefined || item.ExtraParams.CuentaData.Folio === null) {
                item.ExtraParams.CuentaData.Folio = "NA";
                updated = true;
              }
            });
          }

          if (updated) {
            await updateDoc(docRef, {
              Catalogo: rowData.Catalogo
            });
            this.$alert.alertSuccess(`Documento ${id} actualizado con éxito!`);
          } else {
            this.$alert.alertSuccess(`El documento ${id} ya tiene folios configurados.`);
          }
        } else {
          this.$alert.alertError(`El documento ${id} no existe.`);
        }
      } else {
        const data = await firestore.queryBuilder("PDV_CuentaConsumo", [
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant,
          ),
        ]);

        let totalUpdated = 0;
        for (const document of data.docs) {
          const rowData = document.data();
          let updated = false;

          if (rowData.Catalogo && Array.isArray(rowData.Catalogo) && rowData.Catalogo.length > 0) {
            rowData.Catalogo.forEach((item) => {
              if (!item.ExtraParams) {
                item.ExtraParams = {};
              }
              if (!item.ExtraParams.CuentaData) {
                item.ExtraParams.CuentaData = {};
              }
              if (item.ExtraParams.CuentaData.Folio === undefined || item.ExtraParams.CuentaData.Folio === null) {
                item.ExtraParams.CuentaData.Folio = "NA";
                updated = true;
              }
            });
          }

          if (updated) {
            await updateDoc(document.ref, {
              Catalogo: rowData.Catalogo
            });
            totalUpdated++;
          }
        }
        console.log(`Proceso terminado. Se actualizaron ${totalUpdated} documentos.`);
      }
    }
  },
  computed: {
    data_clientes() {
      let data = Cliente.getClientsList();

      data.forEach((cliente) => {
        cliente.value = cliente.id;
        cliente.text = cliente.getNombreCompleto();
      });
      return data;
    },
  },
  watch: {},
  async mounted() {
    await this.getCuentas();
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
};
</script>
